// #region front-end consts
/* KT BADGE STATES */
export const BADGE_BLUE_STATE = 1;
export const BADGE_LIGHTGREEN_STATE = 2;
export const BADGE_VIOLET_STATE = 5;
export const BADGE_GRAY_STATE = 6;
// #endregion


// #region back-end consts
export const SERVICE_USER_ID = 8;
export const SERVICE_PROJECT_ID = 669;

/* USER ROLES */
export const SUPERUSER_ROLE_ID = 1;
export const ADMIN_ROLE_ID = 2;
export const MANAGER_CC_ROLE_ID = 3;
export const TECH_ROLE_ID = 4;
export const BOOKKEEPER_ROLE_ID = 5;
export const USER_ROLE_ID = 6;
export const MANAGER_ROLE_ID = 7;

/* ITEM TYPES */
export const ITEM_REGULAR_TYPE = 1; // обычный продукт
export const ITEM_MASTERCLASS_TYPE = 2;
export const ITEM_COURSE_TYPE = 3;
export const ITEM_LESSON_TYPE = 4;

/* ITEM PRICE TYPES */
export const ITEM_FIXED_PRICE_TYPE = 1;
export const ITEM_DEFERRED_PRICE_TYPE = 2; // рассрочка
export const ITEM_FLOATING_PRICE_TYPE = 3; // плавающая цена
export const ITEM_SUBSCRIPTION_PRICE_TYPE = 4; // рекуррентный платеж

/* MODIFICATOR VALUE TYPES */
export const MODIFICATOR_PERCENT_VALUE_TYPE = 1;
export const MODIFICATOR_ABS_VALUE_TYPE = 2;

/* MODEL MODERATION STATUSES */
export const MODEL_WITHOUT_MODERATION_STATUS = 1;
export const MODEL_MODERATING_STATUS = 2;
export const MODEL_MODERATION_PASS_STATUS = 3;
export const MODEL_MODERATION_FAIL_STATUS = 4;

/* VERIFICATION REQUEST STATES */
export const VERIFICATION_REQUEST_NEW_STATE = 0;
export const VERIFICATION_REQUEST_APPROVED_STATE = 1;
export const VERIFICATION_REQUEST_CANCELED_STATE = 2;

/* MODEL TYPES */
export const USER_MODEL_TYPE = 2;
export const ITEM_MODEL_TYPE = 6;
export const PROJECT_MODEL_TYPE = 7;
export const COURSE_MODEL_TYPE = 12;
export const LESSON_MODEL_TYPE = 14;
export const LESSON_TEXT_MODEL_TYPE = 15;
export const ARTICLE_MODEL_TYPE = 29;
export const FAQ_ARTICLE_MODEL_TYPE = 61;
export const ALERT_MODEL_TYPE = 71;

/* ORGANIZATION FORMS */
export const ORGANIZATION_LLC_FORM = 1;
export const ORGANIZATION_SOLE_PROPRIETOR_FORM = 2;
export const ORGANIZATION_SELF_EMPLOYED_FORM = 3;
export const ORGANIZATION_PHYSIC_FORM = 4;

/* BALANCE TYPES */
export const BALANCE_SELL_TYPE = 1;
export const BALANCE_PARTNER_TYPE = 2;
export const BALANCE_COAUTHOR_TYPE = 3;
export const BALANCE_REFERRAL_TYPE = 4;
export const BALANCE_SECURE_DEAL_TYPE = 9;

/* NPD NOTIFICATION STATES */
export const ACKNOWLEDGED_NPD_NOTIFICATION_STATE = 2;
export const ARCHIVED_NPD_NOTIFICATION_STATE = 3;
// #endregion
